var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleAside',[_c('ScPlaceholder',{attrs:{"name":"jss-content","rendering":_vm.rendering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }